import React, { Component } from "react";
import { NavLink, Link } from "react-router-dom";

const contactnumber = "+800-123-4567 6587";
const location = "Connecting hearts worldwide";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoggedIn: !!localStorage.getItem("token"),
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const header = document.querySelector(".header-section");
    if (!header) return;

    if (window.scrollY > 200) {
      header.classList.add("header-fixed", "fadeInUp");
    } else {
      header.classList.remove("header-fixed", "fadeInUp");
    }
  };

  menuTrigger = () => {
    const menu = document.querySelector(".menu");
    const bar = document.querySelector(".header-bar");
    if (menu) menu.classList.toggle("active");
    if (bar) bar.classList.toggle("active");
  };

  menuTriggerTwo = () => {
    const top = document.querySelector(".header-top");
    if (top) top.classList.toggle("open");
  };

  handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  render() {
    const { isLoggedIn } = this.state;

    return (
      <header className="header-section">
        <div className="header-top">
          <div className="container">
            <div className="header-top-area">
              <ul className="left">
                <li>
                  <i className="icofont-ui-call"></i>{" "}
                  <span>Video & Audio Calls</span>
                </li>
                <li>
                  <i className="icofont-location-pin"></i> {location}
                </li>
              </ul>
              <ul className="social-icons d-flex align-items-center">
                <li>
                  <p>Find us on :</p>
                </li>
                <li>
                  <a href="https://www.facebook.com/profile.php?id=61581327424953" className="fb">
                    <i className="icofont-facebook-messenger"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/profile.php?id=61581327424953" className="twitter">
                    <i className="icofont-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/profile.php?id=61581327424953" className="vimeo">
                    <i className="icofont-vimeo"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/profile.php?id=61581327424953" className="skype">
                    <i className="icofont-skype"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/profile.php?id=61581327424953" className="rss">
                    <i className="icofont-rss-feed"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="header-bottom">
          <div className="container">
            <div className="header-wrapper">
              <div className="logo">
                <Link to="/">
                  <img src="/assets/images/logo/logo.png" alt="logo" />
                </Link>
              </div>
              <div className="menu-area">
                <ul className="menu">
                  <li>
                    <NavLink to="/">Home</NavLink>
                  </li>
                  <li>
                    <NavLink to="/post">Post</NavLink>
                  </li>
                  <li>
                    <NavLink to="/members">All Members</NavLink>
                  </li>
                  <li>
                    <NavLink to="/community">Groups</NavLink>
                  </li>


                  <li>
                    <NavLink to="/gallery">Gallery</NavLink>
                  </li>

                   <li>
                    <NavLink to="/stories">Stories</NavLink>
                  </li>

                  <li>
                    <NavLink to="/chat">Chat</NavLink>
                  </li>

                  <li className="d-block d-lg-none">
                    {isLoggedIn ? (
                      <>
                        <NavLink
                          to="/profile"
                          state={{ userId: localStorage.getItem("user_id") }}
                        >
                          Profile
                        </NavLink>
                        <NavLink
                          as="button"
                          onClick={this.handleLogout}
                          style={{ cursor: "pointer" }}
                        >
                          Logout
                        </NavLink>
                      </>
                    ) : (
                      <NavLink to="/login">Login</NavLink>
                    )}
                  </li>
                </ul>
                {isLoggedIn ? (
                  <div className="d-flex align-items-center">
                    <NavLink
                      to="/profile"
                      state={{ userId: localStorage.getItem("user_id") }}
                      className="login"
                    >
                      <i className="icofont-user-alt-3"></i>{" "}
                      <span>Profile</span>
                    </NavLink>

                    <button
                      onClick={this.handleLogout}
                      className="signup btn btn-danger ms-2"
                    >
                      <i className="icofont-logout"></i> <span>Logout</span>
                    </button>
                  </div>
                ) : (
                  <>
                    <NavLink to="/login" className="login">
                      <i className="icofont-user"></i> <span>LOG IN</span>
                    </NavLink>
                    <NavLink to="/signup" className="signup">
                      <i className="icofont-users"></i> <span>SIGN UP</span>
                    </NavLink>
                  </>
                )}
                <div
                  className="header-bar d-lg-none"
                  onClick={this.menuTrigger}
                >
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <div
                  className="ellepsis-bar d-lg-none"
                  onClick={this.menuTriggerTwo}
                >
                  <i className="icofont-info-square"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default Header;
